import { Button } from '@repo/ui/components/ui/button';

type CommentActionsProps = {
  onSaveClick: () => void;
  saveButtonText?: string;
  onCancelClick: () => void;
  cancelButtonText?: string;
  processing?: boolean;
  saveButtonIcon?: React.ReactNode;
  disabled?: boolean;
};

export const CommentActions = ({
  onSaveClick,
  saveButtonText = 'Save',
  onCancelClick,
  cancelButtonText = 'Cancel',
  processing,
  saveButtonIcon = <></>,
  disabled,
}: CommentActionsProps) => {
  return (
    <div className="flex justify-end">
      <Button variant="ghost" onClick={onCancelClick}>
        {cancelButtonText}
      </Button>
      <Button disabled={processing || disabled} onClick={onSaveClick}>
        {saveButtonText}
        {saveButtonIcon}
      </Button>
    </div>
  );
};
